import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    minHeight: 360,
    [theme.breakpoints.down('tablet')]: {
      minWidth: 320,
    },
    [theme.breakpoints.up('tablet')]: {
      minWidth: 400,
    },

    padding: SPACES.xxl,
  },
  formWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: SPACES.xxxxxxl,
    },
  },
  formWrapperWithHeight: {
    '&&': {
      minHeight: 320,
    },
  },
  inputsWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xxl,
    },
  },
  title: {
    '&&': {
      fontSize: FONTS.SIZES.xxl,
      fontWeight: FONTS.WEIGHTS.bold,
      lineHeight: 1.4,
      textAlign: 'center',

      color: theme.palette.custom.darkBlue2,
    },
  },
  warningText: {
    '&&': {
      color: theme.palette.custom.warning2,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.4,
    },
  },

  addButton: {
    '&&': {
      display: 'flex',
      marginLeft: 'auto',
    },
  },

  startAdornment: {
    '&&': {
      fontSize: '12px',
      fontWeight: 700,
      color: theme.palette.custom.grey2,
      marginRight: '8px',
    },
  },
}))
